import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class CreateAccountExperimentApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CreateAccountExperiment;

  constructor(
    private event: string,
    private category?: string
  ) {
  }

  getPayload(): any {
    return {
      event: this.event,
      category: this.category
    };
  }
}
